import { extendTailwindMerge as e } from "tailwind-merge";
import { twMergeConfig as r } from "../horizon-tailwind-merge-config.js";
const i = e({
  ...r
});
export {
  i as mergeClasses
};
